import { Tag, Tooltip } from '@lokalise/louis'
import type { AiConfigProject } from '@lokalise/translation-api-schemas'
import styles from './ProjectsList.module.css'

type ProjectsListProps = {
  projects: AiConfigProject[]
  maxVisibleProjects?: number
}

export const ProjectsList = ({ projects, maxVisibleProjects = 4 }: ProjectsListProps) => {
  const isListTruncated = projects.length > maxVisibleProjects

  const visibleProjects = projects.slice(0, maxVisibleProjects)
  const truncatedProjects = projects.slice(maxVisibleProjects)

  const tooltip = truncatedProjects.reduce(
    (out, project, index) => (index === 0 ? project.name : `${out}, ${project.name}`),
    '',
  )

  if (!projects || projects.length === 0) {
    return (
      <div className="flex-col gap-2">
        <div className={styles.title}>Activated in projects</div>
        <div className={styles.blankMessage}>Choose projects to activate the configuration</div>
      </div>
    )
  }

  return (
    <div className="flex-col gap-2">
      <div className={styles.title}>Activated in projects</div>
      <div className="flex gap-2">
        {visibleProjects.map(({ name, id }) => (
          <Tag className={styles.tag} key={id}>
            {name}
          </Tag>
        ))}
        {isListTruncated && (
          <Tooltip classNames={{ content: styles.tooltip }} tooltip={tooltip}>
            <div>
              <Tag className={styles.tag} fullWidth>
                {`${truncatedProjects.length} more`}
              </Tag>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  )
}
